export const getCachedSelectedLanguage = () => {
  return localStorage.getItem('i18nextLng') as 'ru' | 'en' | null;
};

export const cacheSelectedLanguage = (value: 'ru' | 'en') => {
  localStorage.setItem('i18nextLng', value);
};
